export const FUEL_TYPE_OPTIONS = [
  "Natural gas",
  "Coal",
  "Petroleum/Gasoline",
  "Diesel",
  "Fuel oil",
  "LPG",
  "Propane",
];

export const FUEL_UNIT_BY_TYPE = {
  "Natural gas": ["M3"],
  Coal: ["Tonnes", "Kg"],
  "Petroleum/Gasoline": ["Liters"],
  Diesel: ["Liters"],
  "Fuel oil": ["Liters"],
  LPG: ["Liters", "Tonnes"],
  Propane: ["Liters", "Tonnes"],
};
